export {default as DialogSwitchPublic} from './DialogSwitchPublic';
export * from './DialogSwitchPublic';
